import { useApplicationState } from '@/hooks/useApplicationState';
import { StripePaymentHandlerPage } from '@/pages/StripePaymentHandlerPage';
import { shouldRenderPaymentHandlerPage } from '@/utils/location';
import { Modal } from '../Common/Modal';
import { Details } from '../Details/Details';
import { Payment } from '../Payment/Payment';
import { ProcessingLoader } from '../ProcessingLoader/ProcessingLoader';
import { Card3DSForm } from '../Card3DSForm/Card3DSForm';
import { ScreenDrawer } from '../ScreenDrawer/ScreenDrawer';
import { RedirectPayment } from '../RedirectPayment/RedirectPayment';
import { PollingStatus } from '@/types/order';
import { SuccessScreen } from '../SuccessScreen/SuccessScreen';
import { useIsMobile } from '@/hooks/useIsMobile';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext } from 'react';
import { XButton } from '../XButton/XButton';

export const OnePaymentTemplate = ({ statusOrderPolling }: { statusOrderPolling: PollingStatus }) => {
  const context = useContext(CheckoutContext);
  const {
    redirectPayment: { redirectUrl, showRedirect },
    successScreen,
    actions: { closeCheckout },
  } = context;
  useApplicationState();
  const isMobile = useIsMobile();

  if (shouldRenderPaymentHandlerPage()) {
    return <StripePaymentHandlerPage />;
  }
  return (
    <Modal>
      <div
        data-testid="checkout-container"
        className="flex flex-col items-center justify-between bg-white w-full h-full pb-4 md:py-4 py-2"
      >
        <XButton onClick={() => closeCheckout(context)} />
        <div className="flex flex-col w-full max-w-[450px] md:max-w-[400px] px-4 gap-0 mt-3 md:mt-10 flex-1 overflow-y-auto">
          <Details />
          <Payment />
        </div>
        <Card3DSForm />
        <ProcessingLoader />
        {isMobile && <ScreenDrawer />}
        {(redirectUrl || showRedirect) && <RedirectPayment />}
        {successScreen?.isOpen && statusOrderPolling === PollingStatus.SUCCESS && <SuccessScreen />}
      </div>
    </Modal>
  );
};
